"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urls = void 0;
var isCloud = false;
var urls = exports.urls = isCloud ? {
  user: '/user',
  jmreport: '/jmreport',
  bpm: '/bpm',
  projectName: '/projectName'
} : {
  user: '',
  jmreport: '',
  bpm: '',
  projectName: ''
};